import React from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "@components/CustomTable";
import { FormatWithCommas } from "@helpers/helpers";
import {
  SINGLE_RECORD,
  REDUCE_TIMEOUT,
  FIRST_ELEMENT,
} from "./constants";
import { ZERO_VALUE } from "@utils/constants";
import NoDataComponent from "@helpers/NoDataComponent";

const RecordsTable = ({
  attemptDetails,
  selectedAttempt,
  columns,
  recordType,
}) => {
  const { t: translate, i18n } = useTranslation();

  const isSourceRecords = recordType === "source";
  const recordIds = isSourceRecords
    ? selectedAttempt.SourcePromotedRecordIds
    : selectedAttempt.DestinationPromotedRecordIds;

  const recordData = attemptDetails.PromotedRecords.filter((record) =>
    recordIds.includes(record.PromotedRecordId)
  );

  const totalAmount = recordData.reduce((acc, record) => {
    return acc + record.Amount;
  }, REDUCE_TIMEOUT);

  const currency = attemptDetails.PromotedRecords[FIRST_ELEMENT].Currency;
  const prefix = isSourceRecords ? "SourceRecords" : "DestinationRecords";
  const translationKey = isSourceRecords
    ? "attempt-details.source-records"
    : "attempt-details.destination-records";

  const pluralSuffix =
    recordData.length > SINGLE_RECORD ||
    recordData.length === ZERO_VALUE ||
    !recordData
      ? "s"
      : "";

  if (!recordData.length) {
    return null;
  }

  return (
    <CustomTable
      language={i18n.language}
      externalData={recordData}
      columnsWithoutPin={columns}
      loading={false}
      pinCondition={() => false}
      pinningInitialState={["pin"]}
      setParentSelectedValues={() => {}}
      prefix={prefix}
      title={`${recordData.length} ${translate(translationKey)} ${pluralSuffix}`}
      secondaryTitle={
        totalAmount
          ? `${currency} ${FormatWithCommas(parseFloat(totalAmount))}`
          : ""
      }
      pinnedRowHeight={62}
      maxTableHeight={400}
      showFilter={false}
      minimalTable={true}
      hideActionColumn={true}
      noData={<NoDataComponent />}
      isExpandable={true}
    />
  );
};

export default RecordsTable;
